import React from "react";
import { CreateOutlined } from "@material-ui/icons";
import { Button } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { useHistory } from "react-router-dom";
import { app_route_ids, app_route_keys } from "constants/urlPaths";

export const ShowEditContactForm = withComponentLibraryTheme(() => {
  const history = useHistory();

  return (
    <div className="tw-flex tw-items-center tw-gap-[10px]">
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        className="tw-h-[32px] tw-text-[14px] tw-border-none"
        onClick={() =>
          history.replace(app_route_ids[app_route_keys.EDIT_CONTACT_FORM])
        }
      >
        <CreateOutlined className="tw-w-[18px] tw-h-[18px] tw-mr-1.5" />
        Manage form
      </Button>
    </div>
  );
});
